import React, { forwardRef } from "react";

import { format, intervalToDuration } from "date-fns";

import { Box, Flex, Spacer, Text, HStack } from "@chakra-ui/react";

import logoMCA from "../../../img-docs/logomca.png";
import { DadosPrincipais } from "./DadosPrincipais";
import { HistoricoMovimentacao } from "./HistoricoMovimentacao";
import { Saude } from "./Saude";
import { Educacao } from "./Educacao";
import { Profissionalizacao } from "./Profissionalizacao";
import { ReferenciaFamiliar } from "./ReferenciaFamiliar";
import { Ocorrencia } from "./Ocorrencia";
import { Visitas } from "./Visitas";
import { Restricoes } from "./Restricoes";
import { Irmaos } from "./Irmaos";
import { SituacaoJuridica } from "./SituacaoJuridica";
import { SituacaoAdocao } from "./SituacaoAdocao";
import { Anexos } from "./Anexos";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { useAppContext } from "../../../Context/MessageContextProvider";
import {
  Permission,
  criancaFunc,
  ocorrenciasFunc,
  referenciaFunc,
  visitasFunc,
  vrCriancaFunc,
} from "../../../helpers/Funcionalidades";
import { Guarda } from "./Guarda";
import { ProgramaApadrinhamento } from "./ProgramaApadrinhamento";
import { ProgramaApadrinhamentoHistorico } from "./ProgramaApadrinhamentoHistorico";
import { Pendencias } from "./Pendencias";

export const ComponentToPrintCrianca = forwardRef((props, ref) => {
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();
  const diferencaAnos = props.data?.dataNascimento
    ? intervalToDuration({
        start: new Date(props.data?.dataNascimento),
        end: new Date(),
      }).years
    : "";

  let primeiraMovimentacao;

  if (
    props?.dataHistoricoMovimentacao &&
    props?.dataHistoricoMovimentacao.length > 0
  ) {
    const movimentacoesComData = props?.dataHistoricoMovimentacao.filter(
      (item) => item.ordem
    );

    if (movimentacoesComData.length > 0) {
      movimentacoesComData.sort((a, b) => b.ordem - a.ordem);
      primeiraMovimentacao = movimentacoesComData[0];
    }
  }
  const visualizarDados =
    (primeiraMovimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
      "Acolhido" &&
      (roleKeycloack?.includes(criancaFunc.visualizarAcolhido) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ)))) ||
    !primeiraMovimentacao?.motivoSituacao?.tipoSituacao?.descricao ||
    (primeiraMovimentacao?.motivoSituacao?.tipoSituacao?.descricao ===
      "Desligado" &&
      roleKeycloack &&
      !roleKeycloack.includes(criancaFunc.visualizarTudoTutelar) &&
      !roleKeycloack.includes(criancaFunc.visualizarTudoDefensoria) &&
      !roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento));

  return (
    <Box display="block" ref={ref} bgColor={"#DDEBEA"}>
      <table>
        <thead>
          <tr>
            <td>
              {/* Header Spacer */}
              <Box height="100px" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Box display="block" px="15px" bgColor={"#DDEBEA"}>
                <DadosPrincipais
                  data={props?.data}
                  idCrianca={props?.idCrianca}
                  dataDocumentacao={props?.dataDocumentacao}
                  imagem={props?.imagem}
                  setImagem={props?.setImagem}
                  columnsRegistro={props?.columnsRegistro}
                  columnsIdentidade={props?.columnsIdentidade}
                  columnsCPF={props?.columnsCPF}
                  ocultarDocumentacao={visualizarDados}
                  roleKeycloack={roleKeycloack}
                  user={user}
                />
                {visualizarDados ? (
                  <>
                    {roleKeycloack &&
                      (roleKeycloack.includes(
                        vrCriancaFunc.movimentoVisualizar
                      ) ||
                        ((roleKeycloack?.includes(
                          criancaFunc.visualizarTudoAcolhimento
                        ) ||
                          roleKeycloack?.includes(
                            criancaFunc.visualizarTudoTutelar
                          )) &&
                          user?.orgaoExterno?.includes(idPJ))) && (
                        <HistoricoMovimentacao
                          data={props?.dataHistoricoMovimentacao}
                          idCrianca={props?.idCrianca}
                        />
                      )}
                    {roleKeycloack &&
                      (roleKeycloack.includes(
                        referenciaFunc.referenciaVisualizar
                      ) ||
                        ((roleKeycloack?.includes(
                          criancaFunc.visualizarTudoAcolhimento
                        ) ||
                          roleKeycloack?.includes(
                            criancaFunc.visualizarTudoTutelar
                          )) &&
                          user?.orgaoExterno?.includes(idPJ))) && (
                        <>
                          <Irmaos data={props?.dataIrmaos} />
                          <ReferenciaFamiliar
                            data={props?.dataReferenciaFamiliar}
                          />
                          <Guarda dataGuarda={props?.dataGuarda} />
                        </>
                      )}
                    <Saude
                      data={props?.dataSaude}
                      idCrianca={props?.idCrianca}
                    />
                    <Educacao data={props?.dataEducacao} />

                    {diferencaAnos >= 16 && (
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={criancaFunc.visualizarProfissionalizacao}
                        id={idPJ}
                        user={user}
                        visualizar={true}
                      >
                        <Profissionalizacao
                          data={props?.dataProfissionalizacao}
                        />
                      </Permission>
                    )}

                    {roleKeycloack &&
                      (roleKeycloack?.includes(ocorrenciasFunc.visualizar) ||
                        ((roleKeycloack?.includes(
                          criancaFunc.visualizarTudoAcolhimento
                        ) ||
                          roleKeycloack?.includes(
                            criancaFunc.visualizarTudoTutelar
                          )) &&
                          user?.orgaoExterno?.includes(idPJ))) && (
                        <Ocorrencia
                          data={props?.dataOcorrencia}
                          idPJ={idPJ}
                          user={user}
                        />
                      )}

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={visitasFunc.visitaVisualizar}
                      user={user}
                      id={idPJ}
                      visualizar={true}
                    >
                      <Visitas data={props?.dataVisita} />
                      <Restricoes data={props?.dataRestricoes} />
                    </Permission>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.visualizarJuridica}
                      user={user}
                      id={idPJ}
                      visualizar={true}
                    >
                      <SituacaoJuridica
                        data={props?.dataProcessoProcedimento}
                        dataVoluntaria={props?.dataEntregaVoluntaria}
                        dataAtribuicao={props?.dataAtribuicaoCompetencia}
                        dataHouveExtincao={props?.dataHouveExtincao}
                      />
                      <SituacaoAdocao dataAdocao={props?.dataAdocao} />
                    </Permission>
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.apadrinhamentoVisualizar}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <ProgramaApadrinhamento
                        data={props?.dataApadrinhamento}
                        idCrianca={props?.idCrianca}
                      />
                    </Permission>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.apadrinhamentoHistoricoVisualizar}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <ProgramaApadrinhamentoHistorico
                        data={props?.dataApadrinhamentoHistorico}
                        idCrianca={props?.idCrianca}
                      />
                    </Permission>

                    {roleKeycloack &&
                      !roleKeycloack.includes(
                        criancaFunc.visualizarTudoDefensoria
                      ) && (
                        <Anexos
                          dataAnexos={props?.dataAnexos}
                          dataNascimento={props?.data?.dataNascimento}
                        />
                      )}

                    {primeiraMovimentacao?.motivoSituacao &&
                      primeiraMovimentacao?.motivoSituacao?.tipoSituacao
                        ?.descricao !== "Desligado" && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={criancaFunc.pendenciasVisualizar}
                          id={idPJ}
                          user={user}
                          visualizar={true}
                        >
                          <Pendencias data={props?.dataPendencias} />
                        </Permission>
                      )}
                  </>
                ) : (
                  ""
                )}
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              {/* Footer Spacer */}
              <Box height="40px" />
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Header */}
      <HStack
        position="fixed"
        top={0}
        px="15px"
        pt="17.5px"
        pb="10px"
        spacing="40px"
        alignItems="center"
        backgroundColor="#FFF"
        zIndex={100}
        width="100%"
      >
        <img
          src={logoMCA}
          alt="LogoMCA"
          style={{ width: "200px", height: "60px" }}
        />
        <Text
          fontWeight={700}
          fontSize="20px"
          lineHeight="21.6px"
          color="#464648"
        >
          {"Ficha da Criança/Adolescente".toUpperCase()}
        </Text>
      </HStack>
      {/* Footer */}
      <Flex
        position="fixed"
        bottom={0}
        pb="17.5px"
        pt="10px"
        w="100%"
        px="15px"
        backgroundColor="#FFF"
        zIndex={100}
      >
        <HStack spacing="35px">
          <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
          <Text>{format(new Date(), "HH:mm:ss")}</Text>
        </HStack>

        <Spacer />

        <Text id="pageForPrint">Página</Text>
      </Flex>
    </Box>
  );
});
